import { render, staticRenderFns } from "./TheNews.vue?vue&type=template&id=2893d72d&scoped=true"
import script from "./TheNews.vue?vue&type=script&lang=js"
export * from "./TheNews.vue?vue&type=script&lang=js"
import style0 from "./TheNews.vue?vue&type=style&index=0&id=2893d72d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2893d72d",
  null
  
)

export default component.exports